// extracted by mini-css-extract-plugin
module.exports = {"container":"_3gcnic6YsyUeqEyRMHo3Aw","icon":"_3GoGV0iPgWjd8AcSBF1ASn","title":"_1YFdmNcRGpR91xzLVwvtGb","text":"_2k2_T9BZyjqDZX4GLKVjH5","retryBtn":"_2wVYAXESIDnlDkVGxc-DxW"};